const marblePolishingService = [
  {
    id: 1,
    title: "Marble Polishing",
    image: "/assets/gallery/k16.jpeg",
    image2: "/assets/gallery/k18.jpeg",
    image3: "/assets/gallery/k12.jpeg",
    shortDescription:
      "Restore the natural shine and elegance of your marble surfaces.",
    description:
      "Our Marble Polishing service is designed to rejuvenate dull and worn-out marble surfaces, bringing back their original luster and beauty. Using advanced tools and techniques, we remove scratches, stains, and etching to leave your marble looking as good as new.",
    description1:
      "We focus on a multi-step process that includes cleaning, grinding, polishing, and sealing to ensure a long-lasting and mirror-like finish. Our team uses specialized equipment and eco-friendly products to maintain the integrity of the marble and ensure a safe environment.",
    description2:
      "In addition to polishing, our service includes filling cracks and repairing minor damages to restore the uniformity and smoothness of your marble surfaces. Whether it's floors, countertops, or walls, we guarantee a professional finish that enhances the elegance of your space.",
    benefits: [
      "Restores natural shine and beauty.",
      "Removes scratches, stains, and etching.",
      "Durable and mirror-like finish.",
      "Eco-friendly products and methods.",
      "Professional and precise application.",
      "Enhances the longevity of marble surfaces.",
    ],
  },
];
export default marblePolishingService;
